import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "../shuttle_bus_booking.css";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import BUS from "../../../assets/Runtime/ic_ bus.svg";

import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { fetchSetMaximumAudit, fetchSetMaximumDetail } from "../../../store/shuttle_bus_booking/set_maximum";
import { Stepper } from "@progress/kendo-react-layout";
import { CustomStep } from "../../../components/common/custom_steps";
import { SHUTTLE_BUS_BOOKING_ROUTE_LIST, SHUTTLE_BUS_BOOKING_ROUTE_ORDINARY_UPDATE, SHUTTLE_BUS_BOOKING_ROUTE_SPECIAL_UPDATE, SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST, SHUTTLE_BUS_BOOKING_SET_STATION_LIST, SHUTTLE_BUS_BOOKING_SET_STATION_UPDATE } from "../../../routes";
import { fetchOrdinaryRouteList, fetchRouteAudit, fetchRouteDetail, fetchSpecialRouteAudit, fetchSpecialRouteDetail, updateRouteStatus, updateSpecialRouteStatus } from "../../../store/shuttle_bus_booking/shuttle_bus_route";
import momentTZ from 'moment-timezone';
import { Icon } from "@progress/kendo-react-common";
import MapIcon from "../../../assets/shuttle_bus_booking/ic_pin.svg";
import EditIcon from "../../../assets/common/EditIcon.svg";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import moment from "moment/moment";


export const ShuttleBusBookingRouteDetail = () => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const type = query.get("type");


  const [showStatus, setShowStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const [activeRoutes, setActiveRoutes] = useState([]);

  const { detail_data, detail_loading, audit_data, audit_loading, ordinary_route_list, special_detail_loading, special_detail_data, special_route_audit_data } = useSelector(
    (state) => state.shuttleBusRoute
  );

  const userPermissions = getUserPermission();

  const viewPermssionSpecial = checkPermission(
    userPermissions,
    "bus_booking.access_special_days"
  );

  const viewPermssionOrdinary = checkPermission(
    userPermissions,
    "bus_booking.access_bus_booking_route"
  );


  const updatePermssionOrdinary = checkPermission(
    userPermissions,
    "bus_booking.update_bus_booking_route"
  );

  const updatePermssionSpecial = checkPermission(
    userPermissions,
    "bus_booking.update_special_days"
  );

  const getData = async () => {
    dispatch(fetchOrdinaryRouteList());
    if (type === 'ordinary') {
      dispatch(fetchRouteDetail(id));
      dispatch(fetchRouteAudit(id));
    } else {
      dispatch(fetchSpecialRouteAudit(id));
      dispatch(fetchSpecialRouteDetail(id));
    }



  };


  const getRouteDetails = async (route_id) => {
    dispatch(fetchRouteDetail(route_id));
  }


  useEffect(() => {
    getData();
  }, [id]);


  const updateStatus = () => {
    setShowStatus(false);

    let params = { status: tempStatus, id: id }

    if (type == 'ordinary') {
      dispatch(updateRouteStatus({ data: params, id: id })).then((res) => {
        getData();
      });
    } else {
      dispatch(updateSpecialRouteStatus({ data: params, id: id })).then((res) => {
        getData();
      });
    }
  };


  const clickUpdateStatus = () => {
    setShowStatus(true);
    if (type == 'oridnary') {
      setTempStatus(detail_data.status);
    } else {
      setTempStatus(special_detail_data.status);
    }
  };


  const parseStationName = (locationString) => {
    const safeString = locationString || '';
    const parts = safeString.match(/^(.*)\((.*)\)$/);
    const mainName = parts ? parts[1].trim() : safeString;
    const subtitle = parts ? `(${parts[2].trim()})` : '  ';

    return { mainName, subtitle };
  };

  const getSortIcon = () => {
    return (<svg width="10" height="14" viewBox="0 0 10 14">
      <path d="M0 6 L5 1 L10 6 Z" fill="#999" />
      <path d="M0 8 L5 13 L10 8 Z" fill="#999" />
    </svg>);
  };


  const buildRouteStops = (routes) => {
    const elements = [];
    const middleElements = [];
    const total = routes.length;

    if (routes.length == 0) {
      return <div>No Data</div>
    }

    for (let i = 0; i < total; i++) {
      const stop = routes[i];
      const isFirst = i === 0;
      const isLast = i === total - 1;
      const isMiddle = !isFirst && !isLast;

      // Parse name
      const { mainName, subtitle } = parseStationName(stop.station_name);

      if (isFirst) {
        elements.push(
          <div key={stop.station_id} className="location-container" style={{ marginLeft: '5px' }}>
            <div className="pin-icon">
              <img alt="" src={BUS} className="shuttle_bus_booking_map_icon" />
            </div>
            <div className="text-container">
              <span className="main-name">{mainName}</span>
              <span className="subtitle">{subtitle}</span>
              <div className="pickup-time-container">
                <div className="pickup-time">{stop?.time}</div>
              </div>
            </div>
          </div>
        );
      }
      else if (isLast) {
        if (routes.length > 2) {
          elements.push(
            <div className="shuttle_bus_detail_route_second_child_box">
              <div className="shuttle_bus_detail_route_second_child_box_arrow_main_box">
                <div className="shuttle_bus_detail_route_second_child_box_arrow_tail"></div>

                <div className="shuttle_bus_detail_route_second_child_box_arrow_head">
                  &#x25BC;
                </div>
              </div>
              <div>{middleElements}</div>
            </div>
          )
        }
        elements.push(
          <div key={stop.station_id} className="location-container" style={{ marginLeft: '5px' }}>
            <div className="pin-icon">
              <img alt="" src={MapIcon} className="shuttle_bus_booking_map_icon" />
            </div>
            <div className="text-container">
              <span className="main-name">{mainName}</span>
              <span className="subtitle">{subtitle}</span>
              <div className="pickup-time-container">
                <div className="pickup-time">{stop?.time}</div>
              </div>
            </div>
          </div>
        );
      } else if (!isFirst) {
        middleElements.push(
          <div key={stop.station_id} className="location-container">
            <div className="text-container" >
              <span className="main-name">{mainName}</span>
              <span className="subtitle">{subtitle}</span>
              <div className="pickup-time-container">
                <div className="pickup-time">{stop?.time}</div>
              </div>
            </div>
          </div>
        );
        middleElements.push(
          <div style={{ height: '15px' }}></div>
        );

      }


      // Add arrow if not the first item





    }

    return elements;
  };

  const renderSpecialDayRoute = () => {
    return <div>
      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Route Type
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {type === 'ordinary' ? 'Ordinary day Route' : 'Special day Route'}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Status
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {special_detail_data?.status}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Route IDs
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {special_detail_data?.active_route_ids?.join(", ")}
        </div>
      </div>


      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Created at
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {special_detail_data?.created_at ? momentTZ.tz(`${special_detail_data?.created_at}`, 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Start Date
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {moment(special_detail_data?.start_date, "YYYY-MM-DD").format("DD MMM YYYY")}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          End Date
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {moment(special_detail_data?.end_date, "YYYY-MM-DD").format("DD MMM YYYY")}
        </div>
      </div>
      <div className="shuttle_bus_booking_detail_child_box_main_detail_box">
        <div className="shuttle_bus_booking_create_item_main_box_title">
          Route Setting
        </div>
        <div style={{
          marginTop: "10px",
          border: "1px solid #eee",
          borderRadius: "5px",
          maxHeight: "500px",
          overflowY: "auto",
          overflowX: "hidden",
        }}>

          <table className="shuttle-bus-booking-detail-table">
            <thead>
              <tr>
                <th>
                  Route ID {getSortIcon()}
                </th>
                <th>
                  Bus Name {getSortIcon()}
                </th>
                <th>
                  Pick-Up Points {getSortIcon()}
                </th>
                <th>
                  Pick-Up Time {getSortIcon()}
                </th>
                <th>
                  Last Destination {getSortIcon()}
                </th>
                <th>
                  Pick-Up Time {getSortIcon()}
                </th>
                <th>
                  Status {getSortIcon()}
                </th>
                <th>
                  Action {getSortIcon()}
                </th>

              </tr>
            </thead>
            <tbody>

              {(ordinary_route_list || []).map((route, index) => (
                <tr key={`route_${index}`} style={{ height: "100px" }}>
                  <td>{route?.route_id}</td>
                  <td>{route?.bus_name}</td>
                  <td>{route?.pickup_station_name}</td>
                  <td>{route?.pickup_time}</td>
                  <td>{route?.destination_station_name}</td>
                  <td>{route?.destination_time}</td>
                  <td style={{ textAlign: "center" }}>
                    <Checkbox
                      style={{ border: "1px solid #CCCCCC" }}
                      name={`route_status_${index}`}
                      value={`route_status_${index}`}
                      disabled={true}
                      checked={special_detail_data?.active_route_ids?.includes(route?.route_id)}
                    />
                  </td>
                  <td><Button
                    className="shuttle-bus-booking-detail-btn font-family-poppins"
                    onClick={() => {
                      getRouteDetails(route?.route_id);
                      setShowDetailPopup(true);
                    }}
                  >
                    Details
                  </Button>
                  </td>


                </tr>
              ))}

            </tbody>
          </table>
        </div>
      </div>


      <div className="shuttle_bus_booking_detail_child_box_main_detail_box" style={{ marginBottom: '50px' }}>
        <div className="shuttle_bus_booking_create_item_main_box_title">
          New custom routes
        </div>
        <div style={{
          marginTop: "10px",
          border: "1px solid #eee",
          borderRadius: "5px",
          maxHeight: "500px",
          overflowY: "auto",
          overflowX: "hidden",
        }}>

          <table className="shuttle-bus-booking-detail-table">
            <thead>
              <tr>
                <th>
                  Route ID {getSortIcon()}
                </th>
                <th>
                  Bus Name {getSortIcon()}
                </th>
                <th>
                  Pick-Up Points {getSortIcon()}
                </th>
                <th>
                  Pick-Up Time {getSortIcon()}
                </th>
                <th>
                  Last Destination {getSortIcon()}
                </th>
                <th>
                  Pick-Up Time {getSortIcon()}
                </th>

              </tr>
            </thead>
            <tbody>

              {(special_detail_data?.custom_routes || []).map((route, index) => (
                <tr key={`custom_route_${index}`} style={{ height: "100px" }}>
                  <td>{route?.route_id}</td>
                  <td>{route?.bus_name}</td>
                  <td>{route?.pickup_station_name}</td>
                  <td>{route?.pickup_time}</td>
                  <td>{route?.destination_station_name}</td>
                  <td>{route?.destination_time}</td>
                </tr>
              ))}

            </tbody>
          </table>
        </div>
      </div>
    </div>;
  };



  const renderOrdinaryDayRoute = () => {
    return <div>
      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Route Type
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {type === 'ordinary' ? 'Ordinary day Route' : 'Special day Route'}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Status
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {detail_data?.status}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Route ID
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {detail_data?.route_id}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Bus Name
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {detail_data?.bus_name}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Created at
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {detail_data?.created_at ? momentTZ.tz(`${detail_data?.created_at}`, 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          First station name
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {detail_data?.pickup_station_name}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Pickup time
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {detail_data?.pickup_time}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Last station name
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {detail_data?.destination_station_name}
        </div>
      </div>

      <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
          Pickup Time
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
          {detail_data?.destination_time}
        </div>
      </div>

      {(detail_data?.routes || []).length > 0 && (<div className="shuttle_bus_booking_detail_child_box_main_detail_items">
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title" style={{ marginTop: '10px' }}>
          Station info
        </div>
        <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
        <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">

          <div className="location-route-container">
            {buildRouteStops(detail_data?.routes || [])}
          </div>

        </div>
      </div>
      )}




    </div>;
  };



  return (
    <>
      {(viewPermssionSpecial || viewPermssionOrdinary) ? (
        <div className="inventory_container">

          {showStatus && (
            <ShowDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={["Active", "Inactive", "Suspension"]}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          {showDetailPopup && (

            <Dialog
              className="alert-form"
              title={"Route Details"}
              width={700}
              // height={280}
              onClose={() => setShowDetailPopup(false)}
            >

              <div className="location-route-container">
                {
                  detail_loading ? (
                    <Loader
                      type="converging-spinner"
                      style={{
                        width: "100%",
                        height: "calc(100% - 75px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#ffffff4d",
                        position: "absolute",
                        zIndex: "999",
                      }}
                    />
                  ) : buildRouteStops(detail_data?.routes || [])
                }
              </div>
            </Dialog>

          )}

          {
            ((detail_loading && type == 'ordinary') || (special_detail_loading && type == 'special')) && (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100% - 75px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            )
          }
          <div className="shuttle_bus_booking_detail_main_box">
            <div className="shuttle_bus_booking_detail_child_box">
              <div className="shuttle_bus_booking_detail_left_box">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    className="shuttle_bus_booking_detail_back"
                    onClick={() => navigate(SHUTTLE_BUS_BOOKING_ROUTE_LIST)}
                  >
                    <span class="k-icon k-font-icon k-i-arrow-chevron-left" />
                    Back
                  </div>

                  {(updatePermssionOrdinary || updatePermssionSpecial) &&
                    <div
                      className="shuttle_bus_booking_detail_edit"
                      onClick={() => {
                        if (type == 'ordinary') {
                          navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_ORDINARY_UPDATE}?id=${id}`)
                        } else {
                          navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_SPECIAL_UPDATE}?id=${id}`)
                        }
                      }}
                    >
                      <img src={EditIcon} />
                      Edit
                    </div>
                  }


                </div>
                <div className={"shuttle_bus_booking_detail_child_box_main_detail_box"}>
                  {type === 'ordinary' ? (renderOrdinaryDayRoute()) : (renderSpecialDayRoute())}
                </div>


              </div>
              <div className="shuttle_bus_booking_detail_right_box">

                {(updatePermssionOrdinary || updatePermssionSpecial) &&

                  <div className="shuttle_bus_booking_detail_right_status_box">
                    <div className="shuttle_bus_booking_detail_right_box_status_title">
                      Status
                    </div>
                    {type == 'ordinary' ? (
                      <div className={detail_data.status == 'Active' ? "shuttle_bus_booking_detail_right_box_status_subdetail" : "shuttle_bus_booking_detail_right_box_status_subdetail_reject"}>
                        {detail_data
                          ? detail_data.status
                          : "-"}
                      </div>
                    ) : (
                      <div className={special_detail_data.status == 'Active' ? "shuttle_bus_booking_detail_right_box_status_subdetail" : "shuttle_bus_booking_detail_right_box_status_subdetail_reject"}>
                        {special_detail_data
                          ? special_detail_data.status
                          : "-"}
                      </div>
                    )
                    }
                  </div>
                }
                {type == 'ordinary' && (<div className="shuttle_bus_booking_detail_right_box_action_main_box">
                  <div className="shuttle_bus_booking_detail_right_box_action_title">
                    Actions
                  </div>

                  <div
                    className="shuttle_bus_booking_detail_right_box_action_edit"
                    onClick={() => clickUpdateStatus()}
                  >
                    Update Status &#x2192;
                  </div>

                </div>
                )}

                <div className="shuttle_bus_booking_detail_right_box_action_main_box">
                  <div className="shuttle_bus_booking_detail_right_box_action_title">
                    Activity Trail
                  </div>
                  {type == 'ordinary' ? (
                    <div className={audit_data.length <= 1 && "audit_bar_hide"}>
                      {audit_loading ? (
                        <Loader
                          type="converging-spinner"
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#ffffff4d",
                          }}
                        />
                      ) : (
                        <Stepper
                          orientation={"vertical"}
                          items={audit_data}
                          item={CustomStep}
                        />
                      )}
                    </div>
                  ) : (
                    <div className={special_route_audit_data.length <= 1 && "audit_bar_hide"}>
                      {audit_loading ? (
                        <Loader
                          type="converging-spinner"
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#ffffff4d",
                          }}
                        />
                      ) : (
                        <Stepper
                          orientation={"vertical"}
                          items={special_route_audit_data}
                          item={CustomStep}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>


          </div>

        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}

    </>
  );
};
